export default __webpack_public_path__ + "images/d97685ce2d6439b2521a63998c8c3244-food_sub.webp";